var swiper = new Swiper('.swiper-container.two', {
    pagination: '.swiper-pagination',
    paginationClickable: true,
    effect: 'coverflow',
    loop: true,
    autoplay: false,
    spaceBetween: 10,
    
    centeredSlides: true,
    slidesPerView: 'auto',
    coverflow: {
      rotate: 0,
      stretch:50,
      depth: 100,
      modifier: 1.5,
      slideShadows: false,
    },
});

document.addEventListener("DOMContentLoaded", function () {
  const swiperContainer = document.querySelector('.swiper-container.two');
  if (!swiperContainer) return;
  const swiper = swiperContainer.swiper;

  // Function to autoplay video on active slide
  function autoplayActiveVideo() {
    const activeSlide = document.querySelector('.swiper-slide-active');
    if (!activeSlide) return;

    const iframe = activeSlide.querySelector('iframe');
    const video = activeSlide.querySelector('video');

    if (iframe) {
      if (iframe.src.includes('youtube')) {
        // YouTube iframe API
        if (!window.YT) {
          let tag = document.createElement('script');
          tag.src = "https://www.youtube.com/iframe_api";
          document.body.appendChild(tag);
        }

        window.onYouTubeIframeAPIReady = function () {
          const player = new YT.Player(iframe, {
            events: {
              'onReady': event => event.target.playVideo(),
              'onStateChange': function (event) {
                if (event.data === YT.PlayerState.ENDED) {
                  slideToNextAndPlay();
                }
              }
            }
          });
        };

        // If API already loaded, create player directly (handles multiple calls)
        if (window.YT && window.YT.Player) {
          new YT.Player(iframe, {
            events: {
              'onReady': event => event.target.playVideo(),
              'onStateChange': function (event) {
                if (event.data === YT.PlayerState.ENDED) {
                  slideToNextAndPlay();
                }
              }
            }
          });
        }

      } else if (iframe.src.includes('vimeo')) {
        // Vimeo API
        if (!window.Vimeo) {
          let script = document.createElement('script');
          script.src = "https://player.vimeo.com/api/player.js";
          document.body.appendChild(script);

          script.onload = () => {
            const player = new Vimeo.Player(iframe);
            player.play();
            player.on('ended', () => slideToNextAndPlay());
          };
        } else {
          const player = new Vimeo.Player(iframe);
          player.play();
          player.on('ended', () => slideToNextAndPlay());
        }
      }
    } else if (video) {
      video.muted = true;
      video.play();
      video.onended = slideToNextAndPlay;
    }
  }

  // Slide to next slide and autoplay next video
  function slideToNextAndPlay() {
    if (swiper.isEnd) return; // If last slide, stop

    swiper.slideNext();

    // Delay to let slide transition complete
    setTimeout(() => {
      autoplayActiveVideo();
    }, 600);
  }

  // On slide change, stop all videos and autoplay current
  swiper.on('slideChangeTransitionStart', () => {
    // Stop all videos and iframes on previous slides
    document.querySelectorAll('.swiper-slide iframe').forEach(iframe => {
      let src = iframe.src;
      iframe.src = "";
      iframe.src = src;
    });
    document.querySelectorAll('.swiper-slide video').forEach(video => {
      video.pause();
      video.currentTime = 0;
    });
  });

  swiper.on('slideChangeTransitionEnd', () => {
    autoplayActiveVideo();
  });

  // Start autoplay on first slide
  autoplayActiveVideo();

  // Your existing code to stop videos on pagination click can stay if needed...
});




/*document.addEventListener("DOMContentLoaded", function () {
    const prevVideoIframe = document.querySelector(".swiper-slide-prev iframe");
    const nextVideoIframe = document.querySelector(".swiper-slide-next iframe");
    const stopButtons = document.getElementsByClassName("swiper-pagination-bullet");

    // Save the original sources
    const originalSrc1 = prevVideoIframe ? prevVideoIframe.src : null;
    const originalSrc2 = nextVideoIframe ? nextVideoIframe.src : null;

    // Loop through all buttons and add event listeners
    Array.from(stopButtons).forEach((stopButton) => {
        stopButton.addEventListener("click", function () {
            if (prevVideoIframe && originalSrc1) {
                prevVideoIframe.src = ""; // Stop the previous video
                setTimeout(() => (prevVideoIframe.src = originalSrc1), 100); // Reset source to enable replay
            }
            if (nextVideoIframe && originalSrc2) {
                nextVideoIframe.src = ""; // Stop the next video
                setTimeout(() => (nextVideoIframe.src = originalSrc2), 100); // Reset source to enable replay
            }
        });
    });
});*/
